module.exports = __webpack_public_path__ + "static/media/ring-line-4-top.0996fb17.svg";